// removed by extract-text-webpack-plugin
module.exports = {"mainPicture":"src-components-Section----MainPicture-module---mainPicture---1wkO1","fh5colead":"src-components-Section----MainPicture-module---fh5colead---3m67C","fh5cosublead":"src-components-Section----MainPicture-module---fh5cosublead---DnaCl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Section/MainPicture.module.scss
// module id = 432
// module chunks = 168707334958949